module.exports = __webpack_public_path__ + "static/media/015.c373f1a3.jpg";